import { useEffect } from 'react';
import { useNavigate, useLocation, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';
import Homepage from "../pages/Homepage";
import LoginPage from "../pages/LoginPage";
import CoursePage from "../pages/CoursePage";
import AdminPannel from "../pages/AdminPannel";
import CourseDetailPage from "../pages/CourseDetailPage";
import MyCoursePage from "../pages/MyCoursePage";
import CommunityPage from "../pages/CommunityPage";
import CoursesListPage from "../pages/CoursesListPage";
import NewsLetterPage from "../pages/NewsLetterPage";
import ServicePage from "../pages/ServicePage";
import WebinarPage from "../pages/WebinarPage";
import CompletedServicePage from "../pages/CompletedServicePage";
import WebinarRegistrationPage from "../pages/WebinarRegistrationPage";
import PaymentHistoryPage from "../pages/PaymentHistoryPage";
import CourseDetail from "../section/mycoursepage/CourseDetail";
import SolutionPage from "../pages/SolutionPage";
import CompletedSolutionPage from "../pages/CompletedSolutionPage";
import WebinarPaymentHistoryPage from "../pages/WebinarPaymentHistoryPage";
import MissionAdminPage from "../pages/MissionAdminPage";
import CourseUsersPage from "../pages/CourseUsersPage";
import CourseAccessPage from "../pages/CourseAccessPage";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import RefundPolicy from "../pages/RefundPolicy";
import TermsConditions from "../pages/TermsConditions";
import PaymentSuccess from "../pages/PaymentSuccess";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('authToken');
  const usertype = Number(localStorage.getItem('usertype') || '2');

  useEffect(() => {
    if (!token) {
      localStorage.setItem('redirectAfterLogin', location.pathname);
      navigate('/login', { 
        state: { 
          from: location.pathname,
          message: "Please login to access this page." 
        } 
      });
      return;
    }

    if (allowedRoles && !allowedRoles.includes(usertype)) {
      if (usertype === 1) {
        navigate('/admin/courseslist');
      } else if (usertype === 3) {
        navigate('/solutions');
      } else {
        navigate('/courses');
      }
    }
  }, [token, usertype, navigate, location, allowedRoles]);

  if (!token || (allowedRoles && !allowedRoles.includes(usertype))) {
    return null;
  }

  return children;
};



export default function Approute() {
  return (
    <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/login" 
          element={
            <GoogleOAuthProvider clientId="547484151794-tbj5l4rhn7lc5ro4c2o59nvp0mt1bql8.apps.googleusercontent.com">
              <LoginPage />
            </GoogleOAuthProvider>
          } 
        />
        <Route 
          path="/courses" 
          element={
            <ProtectedRoute allowedRoles={[2]}>
              <CoursePage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/courseslist" 
          element={
            <ProtectedRoute allowedRoles={[1]}>
              <AdminPannel><CoursesListPage /></AdminPannel>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/courseusers" 
          element={
            <ProtectedRoute allowedRoles={[1]}>
              <AdminPannel><CourseUsersPage /></AdminPannel>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/courseaccess" 
          element={
            <ProtectedRoute allowedRoles={[1]}>
              <AdminPannel><CourseAccessPage /></AdminPannel>
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/newsletter" 
          element={
            <ProtectedRoute allowedRoles={[1]}>
              <AdminPannel><NewsLetterPage /></AdminPannel>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/service" 
          element={
            <ProtectedRoute allowedRoles={[1]}>
              <AdminPannel><ServicePage /></AdminPannel>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/webinar" 
          element={
            <ProtectedRoute allowedRoles={[1]}>
              <AdminPannel><WebinarPage /></AdminPannel>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/completedservice" 
          element={
            <ProtectedRoute allowedRoles={[1]}>
              <AdminPannel><CompletedServicePage /></AdminPannel>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/webinarregistration" 
          element={
            <ProtectedRoute allowedRoles={[1]}>
              <AdminPannel><WebinarRegistrationPage /></AdminPannel>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/coursesdetails" 
          element={
            <ProtectedRoute allowedRoles={[2]}>
              <CourseDetailPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/Mycourse" 
          element={
            <ProtectedRoute allowedRoles={[2]}>
              <MyCoursePage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/mycommunity" 
          element={
            <ProtectedRoute allowedRoles={[2]}>
              <CommunityPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/coursedetail" 
          element={
            <ProtectedRoute allowedRoles={[2]}>
              <CourseDetail />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/paymenthistory" 
          element={
            <ProtectedRoute allowedRoles={[1]}>
              <AdminPannel><PaymentHistoryPage /></AdminPannel>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/webinarpaymenthistory" 
          element={
            <ProtectedRoute allowedRoles={[1]}>
              <AdminPannel><WebinarPaymentHistoryPage /></AdminPannel>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/missionadmin" 
          element={
            <ProtectedRoute allowedRoles={[1]}>
              <AdminPannel><MissionAdminPage /></AdminPannel>
            </ProtectedRoute>
          } 
        />
         <Route 
          path="/solutions" 
          element={
            <ProtectedRoute allowedRoles={[3]}>
              <SolutionPage />
            </ProtectedRoute>
          } 
        />
         <Route 
          path="/completedsolutions" 
          element={
             <ProtectedRoute allowedRoles={[3]}>
              <CompletedSolutionPage />
            </ProtectedRoute>
          } 
        />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/privacy_policy" element={<PrivacyPolicy />} />
        <Route path="/refund_policy" element={<RefundPolicy />} />
        <Route path="/terms_conditions" element={<TermsConditions />} />
      </Routes>
  );
}